import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-muted-foreground text-xs"
}

import { Checkbox } from '@/components/ui/checkbox';
    import { Label } from '@/components/ui/label';
    import { CheckboxGroupRoot } from 'reka-ui';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';

    interface Props {
        columnId: string;
        options: { value: string | number; label: string }[];
        modelValue: (string | number)[];
        title?: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ColumnFilterCheckbox',
  props: {
    columnId: {},
    options: {},
    modelValue: {},
    title: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const { t } = useI18n();

    const emit = __emit;

    const value = computed({
        get: () => props.modelValue,
        set: (newValue) => emit('update:modelValue', newValue),
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(CheckboxGroupRoot), {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      class: "space-y-2"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createBlock(_unref(Label), {
            key: option.value,
            class: "flex items-center gap-2 text-xs"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Checkbox), {
                value: option.value
              }, null, 8, ["value"]),
              _createElementVNode("span", null, _toDisplayString(option.label), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (!_ctx.options.length)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(t)('forms.no_options')), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})